import React, { useEffect, forwardRef } from 'react';
import { useWindowWidth } from '@lux/hooks';
import { screenSizes } from '@lux/tokens';

import {
    SmartBanner as AppSmartBanner,
    AppStoreUrlByCountryKeys,
    BaseSmartBannerProps,
} from '@pegasus/smartbanner';
import { getDeviceOperatingSystem, isSafariBrowserOfiOS } from '@pegasus/utils';

import { getCookie } from '@client/helpers/cookie';
import { useConfig } from '@browsing/config';

export interface SmartBannerProps {
    updateComponentRemovalState: () => void;
    listenToBannerPosition: BaseSmartBannerProps['listenToBannerPosition'];
}

const SmartBanner = forwardRef<HTMLDivElement, SmartBannerProps>(
    ({ updateComponentRemovalState, listenToBannerPosition }, ref) => {
        const { countryCode, isEnabled } = useConfig();
        const localeCountry = countryCode.toLocaleUpperCase();

        let isSmartBannerFeatureEnabled = isEnabled('smartbanner');

        const screenWidth = useWindowWidth();
        const isMobileView = screenWidth <= screenSizes.md;

        // For live test
        if (getCookie('smartbanner_test')) {
            isSmartBannerFeatureEnabled = true;
        }

        useEffect(() => {
            if (!isMobileView || !isSmartBannerFeatureEnabled) {
                updateComponentRemovalState();
            }
        }, [updateComponentRemovalState, isMobileView, isSmartBannerFeatureEnabled]);

        if (!isMobileView || !isSmartBannerFeatureEnabled) {
            return null;
        }

        return (
            <AppSmartBanner
                ref={ref}
                hideInSafariBrowserOfiOS={isSafariBrowserOfiOS()}
                listenToBannerPosition={listenToBannerPosition}
                appPlatform={getDeviceOperatingSystem()}
                localeCountry={localeCountry as AppStoreUrlByCountryKeys}
                onClose={updateComponentRemovalState}
                bannerContext="mylounge"
            />
        );
    },
);

export default SmartBanner;
